import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { Label, Input } from '@shared/components';

interface Props<T extends FieldValues> {
    control: Control<T>;
}

export function CustomerAddressFields<T extends FieldValues>({ control }: Props<T>) {
    return (
        <>
            <Controller
                name={'addressLine1' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="addressLine1">Address Line 1 *</Label>
                        <Input
                            id="addressLine1"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
            <Controller
                name={'addressLine2' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="addressLine2">Address Line 2</Label>
                        <Input
                            id="addressLine2"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
            <Controller
                name={'city' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="city">City *</Label>
                        <Input
                            id="city"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
            <Controller
                name={'postcode' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="postcode">Postcode *</Label>
                        <Input
                            id="postcode"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
        </>
    );
}
